import React, { useEffect, useState } from 'react';
import axios from "axios";

const EmailTable = () => {
    const [emails, setEmails] = useState([]);

    useEffect(() => {
        fetchEmails();
    }, []);

    const fetchEmails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/emails`, {
                credentials: "include",
            });

            const data = await response.data
            setEmails(data);
        } catch (error) {
            console.error("Fehler beim Abrufen der E-Mails: ", error);
        }
    };

    const deleteEmail = async (id) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/emails/${id}`, {
                credentials: "include",
            });

            setEmails(emails.filter((email) => email.id !== id));
        } catch (error) {
            console.error("Fehler beim Löschen der E-Mail: ", error);
        }
    };

    return (
        <table border="1" className="w-3/4 m-auto table-auto bg-gray-200 border-collapse border border-slate-500">
            <thead>
            <tr className="text-lg ">
                <th className="border border-slate-600">ID</th>
                <th className="border border-slate-600">Email</th>
                <th className="border border-slate-600">Aktionen</th>
            </tr>
            </thead>
            <tbody>
            {emails.map((email) => (
                <tr key={email.id}>
                    <td className="border border-slate-600">{email.id}</td>
                    <td className="border border-slate-600">{email.email}</td>
                    <td className="border border-slate-600">
                        <button onClick={() => deleteEmail(email.id)}
                                className="ml-5 bg-red-500 rounded-lg py-1 px-4 my-2 text-white hover:ring-2">Löschen
                        </button>
                        <button onClick={() => deleteEmail(email.id)}
                                className="ml-5 bg-blue-500 rounded-lg py-1 px-4 my-2 text-white hover:ring-2">Send Newsletter
                        </button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};

export default EmailTable;
